import { createAction, props } from '@ngrx/store';



export const deleteSubActionEvent = createAction(
  '[Carousel] Delete SubAction Event',
  props<{ path: string; index: number }>()
);

export const formEventChildEvent = createAction(
  '[Carousel] Form Event Child',
  props<{
    valid: boolean;
    elementVisual: any;
    dataTosaveVisual: any;
    size: any;
    index: number;
    docpath: string;
    action: any;
  }>()
);
